import usePaxSession from "features/shared/hooks/usePaxSession";
import { useLocation } from "react-router-dom";

const useShouldBeVisible = () => {
  const location = useLocation();
  const paxSession = usePaxSession();

  if (location.pathname.includes("select-passenger")) {
    return false;
  }

  return paxSession !== undefined;
};

export default useShouldBeVisible;
